export function toFahrenheit(celsius: number): number {
  return (celsius * 9) / 5 + 32;
}
